import { render, staticRenderFns } from "./Delete_Recored.vue?vue&type=template&id=05c10e0d&"
import script from "./Delete_Recored.vue?vue&type=script&lang=js&"
export * from "./Delete_Recored.vue?vue&type=script&lang=js&"
import style0 from "./Delete_Recored.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports